var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-teams-subitems"},[_c('router-link',{staticClass:"group-teams-subitems__item",attrs:{"to":_vm.routePath}},[_c('BaseIcon',{attrs:{"type":"chevron-right"}}),_c('div',{staticClass:"group-teams-subitems__name"},[_vm._v(_vm._s(_vm.content.text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }